import { getSettingEnableV3SearchWithLoggedOutDiscover } from "@faire/retailer/settings/getSettingEnableV3SearchWithLoggedOutDiscover";
import { useSearchPageIsFromDiscoverURL } from "@faire/retailer/views/search-v2/SearchPageQueryParams/useSearchPageIsFromDiscoverURL";

export const useIsV3SearchWithDiscover = () => {
  const isDiscoverURL = useSearchPageIsFromDiscoverURL();
  return isDiscoverURL && getSettingEnableV3SearchWithLoggedOutDiscover();
};
